/* THIS FILE IS GENERATED ON RUNTIME. DO NOT EDIT */

import { ComponentClassNameFactory } from 'lib/contexts/ComponentClassNameFactory';
import getPropStylesFactory from 'lib/utils/getPropStylesFactory';
import getComponentStylesFactory from 'lib/utils/getComponentStylesFactory';
import getComponentThemeFactory from 'lib/utils/getComponentThemeFactory';
import make_styler from '../index';

export const styles = {
  "button": {},
  "headline_colors_default": "",
  "headline_size_default": "text-al-headline-md",
  "headline_variant_default": "",
  "description_colors_default": "",
  "description_size_default": "text-al-body-sm",
  "description_variant_default": "",
  "image_size_default": "h-42 w-42",
  "image_variant_default": "absolute -z-1 -bottom-11 -right-12 sm:bottom-1.5 sm:right-1.5",
  "colors_default": "bg-al-korall-100",
  "size_default": "w-full sm:pe-40 sm:py-7 sm:pl-7 sm:gap-y-4 gap-y-2 pe-8 py-4 pl-4",
  "variant_default": "flex flex-col items-start not-prose relative z-1 overflow-hidden",
  "image_colors_default": "text-al-korall-600"
};

const c = make_styler(styles);

export const propClassName = getPropStylesFactory(c, styles, "Banner");

export const componentClassName = getComponentStylesFactory(propClassName);

export const componentTheme = getComponentThemeFactory(styles);

export const {
  ClassNameContext,
  ClassNameProvider,
  useClassName,
  useTheme,
} = ComponentClassNameFactory(componentClassName, styles);
  
export default c;